import React, { useState, useEffect } from 'react'
import {
  makeStyles,
  Grid,
  Box,
  Container,
  Typography,
  TextField,
  Button,
} from '@material-ui/core'
import moment from 'moment'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import InputAdornment from '@material-ui/core/InputAdornment'
import CustomizedProgressBars from './ProgressData'
// import Datatable from "./Datatable";
import Cointable from './CoinTable'
import axios from 'axios'
import apiConfig from 'src/APIconfig/ApiConfig'
const useStyles = makeStyles((theme) => ({
  mainsec: {
    background: theme.palette.background.dark1,
    minHeight: '50vh',
  },
}))

function Lastscan({ auth, web3 }) {
  const classes = useStyles()
  const [latestSearchData, setLatestSearchData] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false)

  //false-->>deccreasing // true-->>increasing
  const [filterTable, setFilterTable] = useState({
    score: false,
    interest: false,
    marketcap: false,
    price: false,
    age: false,
  })
  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    userLatestContractScanHandler(res.data.IPv4)
  }
  useEffect(() => {
    getData()
  }, [filterTable])

  const userLatestContractScanHandler = async (ipAddress) => {
    try {
      setIsLoadingData(true)

      const dataToSend = {
        ipAddress: ipAddress,
        interest: filterTable?.interest ? 'High' : 'N/A',
        marketcap: filterTable?.marketcap ? 'High' : 'N/A',
        price: filterTable?.price ? 'High' : 'N/A',
        age: filterTable?.age ? 'High' : 'N/A',
        sortBy: 'N/A',
        score: filterTable?.score ? 'High' : 'N/A',
      }

      // if(filterTable?.interest){
      //   dataToSend.interest === "High"
      // }
      const res = await axios({
        method: 'GET',
        url: apiConfig.userLatestContractScan,
        // headers: {
        //   token: window.sessionStorage.getItem('token'),
        // },
        params: dataToSend,
      })
      if (res.data.responseCode === 200) {
        const filterFun = res.data.result.filter((data) => {
          return data?.contractInfo !== undefined
        })
        setLatestSearchData(filterFun)
        setIsLoadingData(false)
      }
    } catch (error) {
      console.log(error)
      setIsLoadingData(false)
    }
  }
  // useEffect(() => {
  //   let tableData = latestSearchData
  //   if (filterTable.score) {
  //     setIsLoadingData(true)
  //     const filterForScore = tableData.sort(function (a, b) {
  //       return parseFloat(b.contractScan) - parseFloat(a.contractScan)
  //     })
  //     setLatestSearchData(filterForScore)
  //     setIsLoadingData(false)
  //   }
  //   if (filterTable.interest) {
  //     setIsLoadingData(true)
  //     const filterForScore = tableData.sort(function (a, b) {
  //       return parseFloat(b.interest) - parseFloat(a.interest)
  //     })
  //     setLatestSearchData(filterForScore)
  //     setIsLoadingData(false)
  //   }
  //   if (filterTable.age) {
  //     setIsLoadingData(true)
  //     const filterForScore = tableData.sort(function (a, b) {
  //       return (
  //         moment(a?.contractInfo?.age).unix() -
  //         moment(b?.contractInfo?.age).unix()
  //       )
  //     })
  //     setLatestSearchData(filterForScore)
  //     setIsLoadingData(false)
  //   }
  //   if (filterTable.marketcap) {
  //     setIsLoadingData(true)
  //     const filterForScore = tableData.sort(function (a, b) {
  //       return (
  //         parseFloat(b?.contractInfo?.market_cap) -
  //         parseFloat(a?.contractInfo?.market_cap)
  //       )
  //     })
  //     setLatestSearchData(filterForScore)
  //     setIsLoadingData(false)
  //   }
  //   if (filterTable.price) {
  //     setIsLoadingData(true)
  //     const filterForScore = tableData.sort(function (a, b) {
  //       return (
  //         parseFloat(b?.contractInfo?.current_price) -
  //         parseFloat(a?.contractInfo?.current_price)
  //       )
  //     })
  //     setLatestSearchData(filterForScore)
  //     setIsLoadingData(false)
  //   }
  // }, [filterTable, latestSearchData])

  return (
    <>
      <Box className={classes.mainsec}>
        <Container maxWidth="lg">
          <Cointable
            latestSearchData={latestSearchData}
            isLoadingData={isLoadingData}
            web3={web3}
            auth={auth}
            setFilterTable={(data) => setFilterTable(data)}
            filterTable={filterTable}
          />
        </Container>
      </Box>
    </>
  )
}

export default Lastscan
